require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-xw-2-l-5.json") })
        }
      }, "path---photos-professional-xw-2-l-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-xw-2-l-5!./.cache/json/photos-professional-xw-2-l-5.json
// module id = 949
// module chunks = 231608221292675